import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { ExtraButtonsModel } from '@fh-client-interaction-frontends/fh-providers';

@Component({
  selector: 'ui-fh-page-header',
  templateUrl: './fh-page-header.component.html',
  styleUrls: ['./fh-page-header.component.scss']
})
export class FhPageHeaderComponent implements OnChanges {
  @Input() title = '';
  @Input() subtitle? = '';
  @Input() description = '';
  @Input() descriptionParams: { [key: string]: unknown } = {};
  @Input() showStatus: boolean = false;
  @Input() status: string = '';
  @Input() statusTranslatePrefix: string = '';
  @Input() extraButtonsList: ExtraButtonsModel[] = new Array<ExtraButtonsModel>();
  @Input() saveButton: boolean | undefined = false;
  @Input() saveButtonLoading: boolean = false;
  @Input() saveButtonDisabled: boolean = false;
  @Output() saveButtonClicked: EventEmitter<any> = new EventEmitter();
  @Input() addButton: boolean | undefined = false;
  @Input() addButtonLoading: boolean = false;
  @Input() addButtonDisabled: boolean = false;
  @Output() addButtonClicked: EventEmitter<any> = new EventEmitter();
  @Input() editButton: boolean | undefined = false;
  @Input() editButtonLoading: boolean = false;
  @Input() editButtonDisabled: boolean = false;
  @Output() editButtonClicked: EventEmitter<any> = new EventEmitter();
  @Input() deleteButton: boolean | undefined = false;
  @Input() deleteButtonLoading: boolean = false;
  @Input() deleteButtonDisabled: boolean = false;
  @Output() deleteButtonClicked: EventEmitter<any> = new EventEmitter();
  @Input() cancelButton: boolean | undefined = false;
  @Input() cancelButtonLoading: boolean = false;
  @Input() cancelButtonDisabled: boolean = false;
  @Output() cancelButtonClicked: EventEmitter<any> = new EventEmitter();
  @Output() extraButtonClicked: EventEmitter<string> = new EventEmitter<string>();
  @Input() extraButtonLoading: boolean = false;

  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(@Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel,
              private changeDetectorRef: ChangeDetectorRef) {
    this.appConfig = appConfigTemp;
  }

  get normalizedStatus(): string {
    return (this.status || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '_');
  }

  get hasStatus(): boolean {
    return this.showStatus && !!this.normalizedStatus;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.changeDetectorRef.markForCheck();
  }

  clickedButtonHeader(defaultButton: boolean, tag: string) {
    switch (tag) {
      case 'save':
        defaultButton ? this.saveButtonClicked.emit() : this.extraButtonClicked.emit(tag);
        break;
      case 'add':
        defaultButton ? this.addButtonClicked.emit() : this.extraButtonClicked.emit(tag);
        break;
      case 'edit':
        defaultButton ? this.editButtonClicked.emit() : this.extraButtonClicked.emit(tag);
        break;
      case 'delete':
        defaultButton ? this.deleteButtonClicked.emit() : this.extraButtonClicked.emit(tag);
        break;
      case 'cancel':
        defaultButton ? this.cancelButtonClicked.emit() : this.extraButtonClicked.emit(tag);
        break;
      default:
        this.extraButtonClicked.emit(tag);
        break;
    }
  }
}
